import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ContatoIniciativa, CONTATOS_INICIATIVAS } from '../../contato-iniciativa';

interface Config {
    isValid?: boolean;
}

@Component({
    selector: 'sgt-contato-iniciativa-card-control-radio',
    templateUrl: './contato-iniciativa-card-control-radio.component.html',
    styleUrls: ['./contato-iniciativa-card-control-radio.component.less'],
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => ContatoIniciativaCardControlRadioComponent), multi: true },
    ]
})
export class ContatoIniciativaCardControlRadioComponent implements OnInit, OnChanges, ControlValueAccessor {
    config: Config;

    /** Iniciativas */
    iniciativasOptions = CONTATOS_INICIATIVAS;

    /** Iniciativa do contato */
    @Input() ngModel: number;
    /** Ao alterar a iniciativa do contato */
    @Output() ngModelChange = new EventEmitter<number>();

    /** Iniciativa do contato selecionada */
    iniciativa: ContatoIniciativa;
    /** Iniciativa do contato alterada */
    @Output() iniciativaChange = new EventEmitter<ContatoIniciativa>();

    /** Nome do input */
    @Input() name: string;
    /* ID do input */
    @Input() id: string;
    /* Se a iniciativa é obrigatória */
    @Input() required = false;
    /* Se deve desabilitar o input */
    @Input() disabled: boolean;

    @ViewChild('controlInput') controlInput: ElementRef;

    propagateChange: any = () => {};

    ngOnInit(): void {
        this.iniciativa = this.iniciativasOptions.find(iniciativaFilter => iniciativaFilter.id == this.ngModel);
        this.createConfig();
    }

    ngOnChanges(changes: SimpleChanges) {
        for (const propName in changes) {
            if (!changes[propName].isFirstChange()) {
                if (propName === 'ngModel') {
                    this.iniciativa = this.getIniciativa(this.ngModel);
                    this.setIsValid();
                } else if (propName === 'required') {
                    this.setIsValid();
                }
            }
        }
    }

    private createConfig() {
        this.config = {};
        this.setIsValid();
    }

    /** Obtem a iniciativa através do ID */
    private getIniciativa(id: number): ContatoIniciativa {
        if (!id || !this.iniciativasOptions) {
            return null;
        }
        return this.iniciativasOptions.find(iniciativaFilter => iniciativaFilter.id === id);
    }

    /** Ao alterar a iniciativa do contato */
    onChange(iniciativa: ContatoIniciativa) {
        this.ngModel = iniciativa ? iniciativa.id : null;
        this.ngModelChange.emit(this.ngModel);
        this.propagateChange(this.ngModel);

        this.iniciativa = this.iniciativa;
        this.iniciativaChange.emit(this.iniciativa)
    }

    private setIsValid() {
        if (!this.config) {
            return;
        }

        // Obrigatório e não selecionada a iniciativa de contato
        if (this.required && !this.ngModel) {
            this.config.isValid = false;
            return;
        }

        this.config.isValid = true;
    }

    get isValid(): boolean {
        return this.config.isValid;
    }

    /** Seta o focus no select */
    setFocus() {
        jQuery(this.controlInput?.nativeElement).trigger('focus');
    }

    writeValue(value: number) {}

    registerOnChange(fn) {
        this.propagateChange = fn;
    }

    registerOnTouched() {}
}
